import React, { useState } from 'react';
import './settings.css';
import Button from './button';
import { audio_settings, set_audio_setting } from '../audio_settings';
import settings_header from '../assets/settingsheader.png';
import music_icon from '../assets/ChatGPT Image Jun 4, 2026, 02_53_21 PM (8) 1.png';
import sound_icon from '../assets/ChatGPT Image Jun 4, 2026, 02_53_21 PM (9) 1.png';
import vibration_icon from '../assets/ChatGPT Image Jun 4, 2026, 02_53_21 PM (10) 1.png';

const Settings = (props) => {
  const [music, setMusic] = useState(audio_settings.music);
  const [sound, setSound] = useState(audio_settings.sound);
  const [vibration, setVibration] = useState(true);
  const [brightness, setBrightness] = useState(100);

  const toggleMusic = () => {
    set_audio_setting('music', !music);
    setMusic(!music);
  };

  const toggleSound = () => {
    set_audio_setting('sound', !sound);
    setSound(!sound);
  };

  const changeBrightness = (event) => {
    setBrightness(event.target.value);
    document.documentElement.style.setProperty('--screen_brightness', event.target.value / 100);
  };

  return (
    <div className="settings_overlay">
      <div className="settings_panel">
        <Button className="settings_close" onclick={props.onclose}>
          X
        </Button>

        <img className="settings_header" src={settings_header} alt="Settings" />

        <div className="settings_section_title">Gameplay</div>

        <div className="settings_row">
          <img className="settings_row_icon" src={music_icon} alt="" />
          <span>Music</span>
          <Button className={`settings_toggle ${music ? 'settings_toggle_on' : ''}`} onclick={toggleMusic}>
            <div className="settings_toggle_knob" />
          </Button>
        </div>

        <div className="settings_row">
          <img className="settings_row_icon" src={sound_icon} alt="" />
          <span>Sound</span>
          <Button className={`settings_toggle ${sound ? 'settings_toggle_on' : ''}`} onclick={toggleSound}>
            <div className="settings_toggle_knob" />
          </Button>
        </div>

        <div className="settings_row">
          <img className="settings_row_icon" src={vibration_icon} alt="" />
          <span>Vibration</span>
          <Button className={`settings_toggle ${vibration ? 'settings_toggle_on' : ''}`} onclick={() => setVibration(!vibration)}>
            <div className="settings_toggle_knob" />
          </Button>
        </div>

        <div className="settings_section_title">Brightness</div>

        <div className="settings_slider">
          <input
            className="settings_slider_input"
            type="range"
            min="60"
            max="120"
            value={brightness}
            onChange={changeBrightness}
          />
        </div>

        <div className="settings_link_row">
          <div>
            <h2>Privacy Policy</h2>
            <p>Show tutorial on next launch</p>
          </div>
          <Button className="settings_view_button">View</Button>
        </div>

        <div className="settings_link_row">
          <h2>Terms of Service</h2>
          <Button className="settings_view_button">View</Button>
        </div>

        <Button className="settings_save_button" onclick={props.onclose}>
          Save
        </Button>
      </div>
    </div>
  );
}

export default Settings;
